export default "__VITE_ASSET__CLB3qswB__"